import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'ams-check-strength',
  template: `
    <ul #ul id="strength">
      <li class="point"></li>
      <li class="point"></li>
      <li class="point"></li>
      <li class="point"></li>
      <li class="point"></li>
    </ul>
  `,
  styleUrls: ['./check-strength.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class CheckStrengthComponent implements OnChanges {
  @Input()
  public inputStr?: string;
  @Output()
  public outputStr = new EventEmitter<number>();
  @ViewChild('ul', { static: true })
  public ul?: ElementRef;

  public strength = {
    colors: ['#ff7171', '#F90', '#FF0', '#9F0', '#218838'],
    measureStrength: (p: string) => {
      let _force = 0;
      const _regex = /[$-/:-?{-~!"^_`\\[\]]/g;

      const _lowerLetters = /[a-z]+/.test(p);
      const _upperLetters = /[A-Z]+/.test(p);
      const _numbers = /\d+/.test(p);
      const _symbols = _regex.test(p);

      const _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
      const _passedMatches = _flags.filter((el) => el).length;

      _force += 2 * p.length + (p.length >= 10 ? 1 : 0);
      _force += _passedMatches * 10;

      // penality (short password)
      _force = p.length <= 6 ? Math.min(_force, 10) : _force;

      // penality (poor variety of characters)
      _force = _passedMatches === 1 ? Math.min(_force, 10) : _force;
      _force = _passedMatches === 2 ? Math.min(_force, 20) : _force;
      _force = _passedMatches === 3 ? Math.min(_force, 40) : _force;

      return _force;
    },
    getColor: function (s: number) {
      let idx: number;
      if (s <= 10) {
        idx = 0;
      } else if (s <= 20) {
        idx = 1;
      } else if (s <= 30) {
        idx = 2;
      } else if (s <= 40) {
        idx = 3;
      } else {
        idx = 4;
      }
      return { idx: idx + 1, col: this.colors[idx] };
    },
  };

  public ngOnChanges(changes: SimpleChanges): void {
    const currentValue = changes['inputStr'].currentValue;
    if (!this.ul) {
      return;
    }
    if (!currentValue) {
      this.ul!.nativeElement.style.display = 'none';
    }
    const previousValue = changes['inputStr'].previousValue;
    if (this.strength && currentValue && currentValue !== previousValue) {
      const s = this.strength.measureStrength(currentValue);
      const c = this.strength.getColor(s);

      this.ul.nativeElement.style.display = 'inline';
      const li = this.ul.nativeElement.children;

      for (let i = 0; i < li.length; i++) {
        li[i].style.background = '#DDD';
      }

      for (let i = 0; i < c.idx; i++) {
        li[i].style.background = c.col;
      }

      this.outputStr.emit(c.idx);
    }
  }
}
